import rules from './rulesContent/Regulament-pariuri.pdf';
import oktopay from './rulesContent/okto.pdf';
import counterOffer from './rulesContent/counter-offer.pdf';




const termsAndConditions = [
  {
    'title': {
      'eng': 'Rules',
      'rum': "Regulament de Joc"
    },
    'hasSubTabs': false,
    'textTranslationKey': {
      'eng': `<div><embed src="${rules}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
    }
  },
  {
    'title': {
      'eng': 'Counter Offer',
      'rum': "Contra Ofertă"
    },
    'hasSubTabs': false,
    'textTranslationKey': {
      'eng': `<div><embed src="${counterOffer}#toolbar=0&navpanes=0&scrollbar=0&zoom=108" type="application/pdf" width="890px" height="600px" /></div>`,
    }
  }
]

// termsAndConditions.push({
//   title: {
//     eng: 'Okto Pay',
//   },
//   hasSubTabs: false,
//   textTranslationKey: {
//     'eng': `<div><embed src="${oktopay}#toolbar=0&navpanes=0&scrollbar=0&zoom=72" type="application/pdf" width="890px" height="600px" /></div>`,
//   }
// })

export default {
  termsAndConditions
};
